import { motion } from 'framer-motion';
import { CircleCheck, CircleDashed, LoaderCircle, MinusCircle } from 'lucide-react';
import Mascot from '@/components/Mascot';
import { STAGES } from './yieldConstants';

// Avanzamento reale dell'analisi (eventi dallo stream del backend).
export default function YieldProgress({ stages, hasPhotos, hasPoint, retry }) {
  const list = STAGES.filter(s => (s.k !== 'vision' || hasPhotos) && (s.k !== 'region' || hasPoint));
  return (
    <div className="rounded-2xl glass-vp p-8" data-testid="yield-progress">
      <div className="flex justify-center mb-3"><Mascot pose="analyze" size={120} spinning/></div>
      <div className="text-center font-display text-xl tracking-tight">Yield AI PRO in azione…</div>
      <div className="mt-6 space-y-2.5 max-w-sm mx-auto">
        {list.map((s, i) => {
          const st = stages[s.k];
          const status = st?.status || 'pending';
          const Icon = status === 'done' ? CircleCheck : status === 'running' ? LoaderCircle : status === 'skipped' ? MinusCircle : CircleDashed;
          return (
            <motion.div key={s.k} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.06 }}
                        className={`flex items-center gap-3 rounded-xl px-3 py-2.5 border text-sm transition-colors ${status === 'running' ? 'border-chartreuse/40 bg-chartreuse/5' : 'border-border'}`}
                        data-testid={`yield-progress-stage-${s.k}`} data-status={status}>
              <Icon size={16} className={`${status === 'done' ? 'text-chartreuse' : status === 'running' ? 'text-chartreuse animate-spin' : status === 'skipped' ? 'text-terracotta' : 'text-muted-foreground'} shrink-0`}/>
              <span className={status === 'pending' ? 'text-muted-foreground' : ''}>{s.l}</span>
              {st?.detail && <span className="ml-auto text-[11px] text-muted-foreground truncate max-w-[45%]">{st.detail}</span>}
            </motion.div>
          );
        })}
      </div>
      {retry && <div className="mt-4 text-center text-xs text-terracotta">{retry}</div>}
      {hasPhotos && <div className="mt-5 text-center text-[11px] text-muted-foreground">L'analisi delle foto richiede di solito 15-40 secondi.</div>}
    </div>
  );
}
